import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useLazyGoals } from '@atlassian/jira-portfolio-3-atlas-goals';
import { VIEW_MODES } from '@atlassian/jira-portfolio-3-common';
import Roadmap from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap';
import PlanTableAsync from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/table/async';
import { connect } from '@atlassian/jira-react-redux';
import mapStateToProps from './query';
import type { ExportProps } from './types';

// When cleaning up FF com.atlassian.rm.jpo.transposition we can remove this component entirely
const RoadmapExportWrapper = ({ viewMode, isLoading, onLoadComplete, ...props }: ExportProps) => {
	const [{ lazyGoalsByARI }] = useLazyGoals();
	const isGoalsLoading = Object.values(lazyGoalsByARI).some((goal) => goal.isLoading);

	if (ff('com.atlassian.rm.jpo.transposition')) {
		if (!isLoading && !isGoalsLoading && onLoadComplete) {
			// NOTE: Similar to src/packages/portfolio-3/portfolio/src/app-export-view/view/main/view.tsx,
			// calling setTimeout here to make sure export preview snapshot is captured when all fields are ready,
			// otherwise the preview may not render correctly when the plan is small and in list mode (basically too few elements to render)
			// TODO: Find a better way to ensure isLoading is marked at a reliable timing
			setTimeout(() => {
				onLoadComplete();
			}, 100);
		}

		if (ff('com.atlassian.rm.jpo.transposition.m2')) {
			return <PlanTableAsync />;
		}

		return viewMode === VIEW_MODES.TIMELINE ? <Roadmap {...props} /> : <PlanTableAsync />;
	}

	return <Roadmap {...props} />;
};

export default connect(mapStateToProps, {})(RoadmapExportWrapper);
